export default () => `
<footer>
    <img src="https://i.imgur.com/cJsy8d1.jpg" id="left">
    <img src="https://i.imgur.com/cJsy8d1.jpg" id="right">
    <h1 id="wateringHole">Local Watering Hole</h1>
    <h4 id="connect">Connect with other anglers to share tips, favorite places, and secrets.</h4>
    
    <section id="ninjaUsers">
    </section>
</footer>

<!-- Create Modals -->
<div class="modalBg">
    <div class="modalContent">

    </div>
    <span id="modal-close">X</span>
</div>
`